import * as z from "zod";

/** What each tab holds, so a surface can badge both without fetching either. */
export const getKnowledgeCounts = {
  name: "getKnowledgeCounts" as const,
  input: z.object({}),
  output: z.object({
    itemCount: z.number(),
    pendingSuggestionCount: z.number(),
    productKnowledgeCount: z.number(),
    /** True when retrieval would find an active entry in its window. */
    hasRetrievableKnowledge: z.boolean(),
  }),
};
